import React, { useState, useEffect } from 'react'
// COMPONENTS
import HeaderReturn from './../../../components.js/serveur/siteWeb/HeaderReturn'
// GOOGLE MAP
import GoogleMapReact from "google-map-react"
// import MyMarker from "./MyMarker"

const NousSituerUsersPage = () => {
    const [keyUid, setKeyUid] = useState(localStorage.getItem('keyUid'))
    const [tokenUser, setTokenUser] = useState(localStorage.getItem('tokenUser'))

    useEffect(() => (
        <a href="https://www.google.fr/maps?hl=fr&tab=rl&authuser=0">Visit W3Schools.com!</a>   
    ),[])

    return (
        <div className='container-fluid'> 
            <HeaderReturn title='Nous situer' link={'/homeUser/'+keyUid+'/'+tokenUser}/>
            <a href="https://www.google.fr/maps/place/Aux+2+fauteuils/@47.8749875,-3.0217366,17z/data=!3m1!4b1!4m5!3m4!1s0x4810398474dfebdd:0xcd166f48df61c7f9!8m2!3d47.8749839!4d-3.0195479?hl=fr&authuser=0">Visit W3Schools.com!</a>   
        </div> 
    )
}

export default NousSituerUsersPage

/*
        /<div className='container-fluid'> 

            // HEADER RETOUR 
            <HeaderReturn title='Nous situer' link={'/homeUser/'+keyUid+'/'+tokenUser}/>
*/
